export { CollectionsContent } from "./CollectionsContent";
